import React from "react";
import { Outlet } from "react-router-dom";

const LayoutEtiquetas = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default LayoutEtiquetas;
